import { render, staticRenderFns } from "./ChartTestCountOvertime.vue?vue&type=template&id=974e4a26&"
import script from "./ChartTestCountOvertime.vue?vue&type=script&lang=js&"
export * from "./ChartTestCountOvertime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports